import React from 'react';
import { Link } from 'react-router-dom';
import HtmlContent from '../components/common/HtmlContent';

/**
 * HomePage Component
 * 
 * Matches the legacy site's home page structure exactly as seen in the original HTML files
 */
const HomePage = () => {
  // Introduction content matching tk-introduction.html
  const introductionHtml = `
    <p>
    Creating new things is hard, failure is the rule, not the exception. However, whether we succeed or fail, it is important to document the process so that lessons can be learned, mistakes can be identified and things can be improved - leading to efficiencies and ultimately a delightful product that fulfils a user's needs.
    </p>

    <p>
    I created this toolkit as my Second Brain - a means to document the various frameworks, processes, tools and methodologies that I have come across that have emerged primarily through Design Thinking - all in order to help carve out the right product for the user, the market and the business <b>rapidly</b>. 
    </p>

    <p>
    The toolkit is split in to 4 core sections; Research, Design (TBC), Product (TBC) and Delivery - these are the general areas that need to be covered in order to develop and launch products.
    </p> 

    <p>
    Some notes on this toolkit;

        <ul class="bullet-tk">
            <li>These 'tools' are not extensive, there are plenty more out there, but are just what I've come across, and what I like.</li>
            <li>A lot of this stuff is theory, and we all have our own interpretations of things - these are of course my interpretations.</li>
            <li>Despite the ordering of the tools, this toolkit is non-linear, so jumping around a bit is expected and encouraged!</li>
        </ul>
    </p>
  `;

  return (
    <>
      {/* Introduction Section */}
      <main className="case-study">
        <span className="case-tool-title-introduction case-tool-title" id="introduction">&nbsp;&nbsp;</span>
        <div className="linebreak"></div>
        <div className="tool-title-wrap">
          <div className="tool-title-icon"><i className="fas fa-tools fa-2x"></i></div>
          <div className="tool-title" id="introduction"><span className="tool-title-number"><Link to="/#introduction">Introduction</Link></span></div>
          <div className="tool-title-nav"><Link to="/">R&D Toolkit</Link>&nbsp;&nbsp;<i className="fas fa-angle-double-right"></i>&nbsp;&nbsp;<Link to="/">Overview</Link></div>
          <div className="tool-title-link"><Link to="/#introduction"><i className="fas fa-link fa-2x"></i></Link></div>
        </div>
        
        <div className="linebreak"></div>

        <div className="tool-box-styling">
          <div className="tool-opening-container">
            <div className="tool-opening">
              <HtmlContent html={introductionHtml} containerClass="" />
              
              <br />

              <div className="tool-section-title">Product R&D Toolkit Sections</div>
              
              <div className="tool-section-list-parent">
                <div><Link className="tool-section-cta" to="/research">Research</Link></div>
                <div><Link className="tool-section-cta" to="/design">Design</Link></div>
                <div><Link className="tool-section-cta" to="/delivery">Delivery</Link></div>
                <div><Link className="tool-section-cta" to="/resources">Resources</Link></div>
              </div>
            </div>
          </div>
        </div>
      </main>

      {/* Recent Updates Section */}
      <main className="case-study">
        <span className="case-tool-title" id="recent-updates">&nbsp;&nbsp;</span>
        <div className="linebreak"></div>
        <div className="tool-title-wrap">
          <div className="tool-title-icon"><i className="fas fa-tools fa-2x"></i></div>
          <div className="tool-title" id="recent-updates"><span className="tool-title-number"><Link to="/#recent-updates">Recent Updates</Link></span></div>
          <div className="tool-title-nav"><Link to="/">R&D Toolkit</Link>&nbsp;&nbsp;<i className="fas fa-angle-double-right"></i>&nbsp;&nbsp;<Link to="/">Overview</Link></div>
          <div className="tool-title-link"><Link to="/#recent-updates"><i className="fas fa-link fa-2x"></i></Link></div>
        </div>

        <div className="linebreak"></div>

        <br />
        
        <table id="tool-table">
          <tbody>
            <tr className="table-section-tools-parent">
              <td>Date</td>
              <td>Update</td>
            </tr>
            <tr>
              <td>14/10/2023</td>
              <td>Added Design section. </td>
            </tr>
            <tr>
              <td>19/10/2020</td>
              <td>Phase 1 of the Toolkit is now complete.</td>
            </tr>
            <tr>
              <td>09/10/2020</td>
              <td>Phase 1 virtually complete, just working on resources and then need to do some admin.</td>
            </tr>
            <tr>
              <td>10/08/2020</td>
              <td>Soft launch - just uploaded the site, currently debugging and proof reading.</td>
            </tr>
          </tbody>
        </table>

        <br />
      </main>
    </>
  );
};

export default HomePage; 